$(function() {

  // Dont do anything if the user isnt active
  if (!currentUser.subscriber) {
    return;
  }

  // Show the tooltip?
  var bookmarkCookie = Cookies.getJSON('bookmark-cookie'),
      initialbookmarkValues = {
        visitCount: 0,
        valid: true
      },
      bookmarkVisitCount,
      bookmarkExpirationWindow;

  if (!bookmarkCookie) {
    Cookies.set('bookmark-cookie', initialbookmarkValues, { expires: 60 });
    bookmarkCookie = initialbookmarkValues;
  }

  // Get the current visit count
  bookmarkVisitCount = bookmarkCookie.visitCount;
  // As long as the visit count is under X, show the tooltip
  if (bookmarkCookie.valid && bookmarkVisitCount <= 10) {
    Cookies.set('bookmark-cookie', {visitCount: bookmarkVisitCount + 1, valid: true}, {expires: 60});
  } else {
    Cookies.set('bookmark-cookie', { valid: false }, {expires: 60});
  }
});
